
export const CSV_ON_WAY_MESSAGE = 'Top Leads CSV file has been successfully sent to your email.';
export const CSV_REPORTS_ON_WAY_MESSAGE = 'Your report is being generated, ' +
    'you should receive an email with your report in approximately 2 minutes.';
export const UNEXPECTED_ERROR = 'Something went wrong. Our team is currently looking into this.';
